// extracted by mini-css-extract-plugin
export default {"card__container":"card-layout_card__container__3RZwT","card__title":"card-layout_card__title__d6wUf"};